import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';

/**
 * The handle the debug drawer opens from: a tab on the right edge of the window, present whenever
 * the drawer is closed. On the edge rather than in the top bar because that is where the panel comes
 * from, and because the log is opened often enough that it should not be one icon among six.
 */
export function DebugTab({ onOpen }: { onOpen: () => void }) {
  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, x: 8 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 8 }}
      transition={{ duration: 0.18, ease: [0.16, 1, 0.3, 1] }}
      onClick={onOpen}
      title="Debug log (Ctrl+Shift+D)"
      className="dbg-tab"
    >
      <Activity className="size-3.5 shrink-0" />
      <span className="dbg-tab-label">Debug</span>
    </motion.button>
  );
}
